import React, {useState} from 'react';
import {StyledMenu, MobileMenu, Position} from './StyledMenu';
import {Mobile, Desktop} from '../../rwd/rwd';
import StyledHamburger from "./StyledHamburger";

const Menu = ({links}) => {

    const [isVisible, setIsVisible] = useState(false);

    const toggleVisible = () => {
        setIsVisible(!isVisible);
    };

    return (
        <>
            <Desktop>
                <StyledMenu>
                    {links.map(link => <Position isMobile={false} to={link.link}>{link.name}</Position>)}
                </StyledMenu>
            </Desktop>
            <Mobile>
                <StyledHamburger open={isVisible} onClick={toggleVisible}>
                    <div/>
                    <div/>
                    <div/>
                </StyledHamburger>
                <MobileMenu open={isVisible}>
                    {links.map(link => <Position onClick={() => setIsVisible(false)}
                                                 isMobile={true}
                                                 to={link.link}>{link.name}</Position>)}
                </MobileMenu>
            </Mobile>
        </>
    );
};

export default Menu;
